import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { AtSign, User } from '~/Components/Icons';
import { AccessList, useHasAccess, useProvider } from '~/Hooks';
import { StaffEditCustomImage } from '../StaffEditCustomElements';
import { StaffRoleSelect } from '../StaffEditCustomElements/StaffRoleSelect';
import { useItemCreationContext } from '~/ModularComponents';
import {
  InputSwitcher,
  InputText,
  ItemCreationInputsContainer,
  ItemCreationInputTemplate,
} from '~/ModularComponents/ItemCreationInputs';
import { FitogramCircle } from '~/Components/Icons/brand/FitogramCircle';

export const StaffEditSection = () => {
  const boundariesElement = useRef(null);

  const { t } = useTranslation();
  const { hasAccess } = useHasAccess();
  const { isUsingThePartnerTool } = useProvider();
  const { values: staff, setDisabled } = useItemCreationContext();

  useEffect(() => {
    if (staff && staff.id) {
      setDisabled?.({ firstName: true, lastName: true, email: true });
    } else {
      setDisabled?.({ firstName: false, lastName: false, email: false });
    }
  }, [staff, setDisabled]);

  return (
    <div ref={boundariesElement}>
      <ItemCreationInputsContainer title="STAFF_DETAILS_SECTION">
        <StaffEditCustomImage />
      </ItemCreationInputsContainer>
      <ItemCreationInputsContainer title={t('settings.staff.personalInformation')} isHeaderVisible>
        <ItemCreationInputTemplate
          name="firstName"
          noIconBackground
          InputElement={
            <InputText
              name="firstName"
              label={`${t('app.firstName')}*`}
              placeholder={t('app.firstName')}
              icon={<User />}
              maxLength={50}
            />
          }
        />
        <ItemCreationInputTemplate
          name="lastName"
          noIconBackground
          InputElement={
            <InputText
              name="lastName"
              label={`${t('app.lastName')}*`}
              placeholder={t('app.lastName')}
              icon={<User />}
              maxLength={50}
            />
          }
        />
        <ItemCreationInputTemplate
          name="email"
          noIconBackground
          InputElement={
            <InputText
              name="email"
              label={`${t('app.email')}*`}
              placeholder={t('app.email')}
              icon={<AtSign />}
              maxLength={50}
            />
          }
        />
      </ItemCreationInputsContainer>
      {hasAccess(AccessList.SET_ORGANISATION_MANAGER) && (
        <ItemCreationInputsContainer title={t('access.role.organisationManager')} isHeaderVisible>
          <ItemCreationInputTemplate
            name="isOrganisationManager"
            noIconBackground
            label={t('access.role.organisationManager')}
            icon={<FitogramCircle />}
            InputElement={<InputSwitcher name="isOrganisationManager" />}
          />
        </ItemCreationInputsContainer>
      )}
      <ItemCreationInputsContainer
        tooltip={{
          title: isUsingThePartnerTool
            ? t('settings.staff.access.partner.tooltip')
            : t('settings.staff.access.provider.tooltip'),
          boundariesElement: boundariesElement.current,
        }}
        title={t('form.title.staffAccess')}
        isHeaderVisible
      >
        <StaffRoleSelect />
      </ItemCreationInputsContainer>
    </div>
  );
};
